import React from 'react';
import styles from './index.module.scss';
import { RightOutline, DownOutline, FillinOutline } from 'antd-mobile-icons';
import { Divider } from 'antd-mobile-v5';
import { useHistory } from 'react-router-dom';

const EPROQuantitative = (props: any) => {
    const history: any = useHistory();

    // props.state 报状态：0：未上报，1：已上报，2：重报
    const toRecord = () => {
        const item = props.item;
        history.push(`/epro/patient/home/record?subjectCode=${props.subjectCode}&scaleCode=${item.code}&scaleName=${item.name}&visitId=${props.visit?.id || ''}`) 
    }

    return (
        <div className={`${styles.container} ${props.state === 0 ? '' :  styles.writed}`} >
            <div className={styles.header} >
                <div className={styles.name}>{props.name}</div>
              
                {
                    props.editModel === 1 &&  <div className={styles.doReport} onClick={props.onReport}>{props.state === 0 ? '立即填写' : props.state === 1 ? '点击查看': '重新填写'}<RightOutline/></div>
                }
                {
                    props.editModel !== 1 &&  <div className={styles.doReport} onClick={props.onReport} >{props.state === 0 ? '立即填写' :  '重新填写'}<RightOutline/></div>
                }
            </div>
            <div className={styles.body}>
                <div className={styles.bodyLeft}>
                    <div className={styles.quantEn}>{props.code}</div>
                    <div className={styles.question}>
                        { 
                            props.state === 0 ? 
                            <img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_writ1701423018497.png'/>:
                            <img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_writed1701423018497.png'/>
                        }
                        {props.questionCount}题 / {props.time}
                    </div>
                </div>
                <div className={styles.bodyRight}>
                    {
                        props.state == 0 ?  <img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_report1701423018497.png'></img>
                        :<img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/epro_patient/icon_reported1701423018497.png'></img>
                    }
                </div>
            </div>{

                props.editModel !== 1 && 
                <>
                    <Divider/>
                    <div className={styles.footer} onClick={toRecord}>
                        <div className={styles.reportCount}>上报填写记录（{props.count || 0}）</div>
                        {/* <div className={styles.btnMore}>展开<DownOutline/></div> */}
                    </div>
                </>
            }
            
        </div>
    )
}

export default EPROQuantitative